import { ieltsThemeAtom } from "@/store/home";
import { IeltsTheme } from "@/types";
import { useAtomValue } from "jotai";
import Image, { StaticImageData } from "next/image";
import DiamondV2 from "@/components/diamonds/images/diamond.svg";
import React from "react";

function ItemPoint({
  data,
  iconPrefix,
  iconPrefixAfter,
  onClick,
}: {
  data: number;
  iconPrefix: React.ReactNode | StaticImageData;
  iconPrefixAfter: React.ReactNode | StaticImageData;
  onClick?: () => void;
}) {
  const ieltsTheme = useAtomValue(ieltsThemeAtom);
  return (
    <>
      {ieltsTheme === IeltsTheme.GAMIFICATION ? (
        <div
          onClick={onClick}
          className="flex items-center justify-center min-w-[78px] lg:min-w-[170px] h-[20px] lg:h-[34px] relative bg-[#04221E] text-white rounded-[4px] px-[2px]"
        >
          <span className="absolute left-0 top-[-2px] lg:top-0 w-[24px] h-[24px] lg:w-[34px] lg:h-[34px]">
            <Image alt="part" src={iconPrefix as StaticImageData} className="w-full" />
          </span>
          <div className="text-center font-semibold px-[30px] text-[12px] xl:text-[16px]">{data}</div>
          <span className="absolute right-[-10px] lg:right-[-15px] top-[-5px] w-[26px] h-[26px] lg:w-[46px] lg:h-[46px]">
            <Image alt="part" src={iconPrefixAfter as StaticImageData} className="w-full" />
          </span>
        </div>
      ) : (
        <div
          onClick={onClick}
          className="flex items-center justify-center h-[42px] relative rounded-[40px] border-[1px] border-[#E7E7E7] px-[10px] md:px-[36px] bg-white"
        >
          <div className="flex items-center gap-[5px]" style={{ color: "#515159" }}>
            Diamond: <DiamondV2 width={20} height={20} />
            <strong>{data}</strong>
          </div>
        </div>
      )}
    </>
  );
}

export default ItemPoint;
